import { render, staticRenderFns } from "./AmountDisplayerFilterable.vue?vue&type=template&id=c5c4cb46"
import script from "./AmountDisplayerFilterable.vue?vue&type=script&lang=ts"
export * from "./AmountDisplayerFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports